import html from "./images/HTML5.png"
import css from "./images/css.png"
import js from "./images/JavaScript.png"
import react from "./images/react.png"
import python from "./images/python.png"
import node from "./images/Node.png"
import express from "./images/express.webp"
import flask from "./images/flask.png"
import php from "./images/php.png"
import langchain from "./images/langchain.png"
import langgraph from "./images/langgraph.png"
import bootstrap from "./images/bootstrap.png"
import tailwind from "./images/Tailwind.png"
import postgres from "./images/postgres.png"
import mysql from "./images/mySQL.png"
import git from "./images/git.png"
import postman from "./images/poostman.png"
import passport from "./images/passport.png"


const Toolkit = [
    {
        "category": "Frontend",
        "tools": [
            {
                "title": "HTML5",
                "image": html
            },
            {
                "title": "CSS3",
                "image": css
            },
            {
                "title": "JavaScript",
                "image": js
            },
            {
                "title": "React",
                "image": react
            },
            {
                "title": "Bootstrap",
                "image": bootstrap
            },
            {
                "title": "Tailwind",
                "image": tailwind
            }
        ]
    },
    {
        "category": "Backend & Runtime",
        "tools": [
            {
                "title": "Python",
                "image": python
            },
            {
                "title": "Node.js",
                "image": node
            },
            {
                "title": "Express",
                "image": express
            },
            {
                "title": "Flask",
                "image": flask
            },
            {
                "title": "langchain",
                "image": langchain
            },
            {
                "title": "langgraph",
                "image": langgraph
            },
            {
                "title": "php",
                "image": php
            },
            {
                "title": "Passport",
                "image": passport
            }
        ]
    },
    {
        "category": "Databases",
        "tools": [
            {
                "title": "PostgreSQL",
                "image": postgres
            },
            {
                "title": "MySQL",
                "image": mysql
            }
        ]
    },
    {
        "category": "DevOps & Tools",
        "tools": [
            {
                "title": "Git",
                "image": git
            },
            {
                "title": "Postman",
                "image": postman
            }
        ]
    },

]

export default Toolkit;